<template>
  <div class="my-page-container">
    <!-- 已登录状态 -->
    <div v-if="isLoggedIn" class="my-page">
      <!-- 用户信息头部 -->
      <div class="user-header">
        <div class="user-avatar">
          <van-image round width="80" height="80"
            :src="userInfo.avatar || defaultAvatar" fit="cover" />
        </div>
        <div class="user-details">
          <div class="user-name">{{ userInfo.name }}</div>
        </div>
      </div>

      <!-- 用户数据概览 -->
      <!-- <div class="user-stats">
        <div class="stat-item">
          <div class="stat-value">0</div>
          <div class="stat-label">比赛场次</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">0</div>
          <div class="stat-label">最高分</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">0</div>
          <div class="stat-label">平均分</div>
        </div>
      </div> -->

      <!-- 功能菜单 -->
      <div class="menu-section">
        <div class="section-title">我的服务</div>
        <van-grid :column-num="3" :border="false" :gutter="10">
          <van-grid-item icon="user-o" text="我的信息" to="myBowlerInfo" />
          <van-grid-item icon="medal-o" text="我的比赛" to="myMatchInfo" />
          <van-grid-item icon="balance-o" text="我的消费" to="myAccountStatement" />
          <van-grid-item icon="chart-trending-o" text="我的分数" to="myScore" />
        </van-grid>
      </div>

      <!-- 其他功能区域 -->
      <div class="other-services">
        <div class="section-title">其他服务</div>
        <van-cell-group inset>
          <van-cell title="绑定手机" icon="phone-o" is-link to="/bindToPhone" />
          <van-cell title="识别码" icon="info-o" is-link to="/MyIdCode" />
          <!-- <van-cell title="设置" icon="setting-o" is-link />
          <van-cell title="帮助中心" icon="question-o" is-link />
          <van-cell title="关于我们" icon="info-o" is-link /> -->
          <van-cell title="退出登录" icon="close" is-link @click="handleLogout" class="logout-cell" />
        </van-cell-group>
      </div>
    </div>

    <!-- 未登录状态 -->
    <div v-else class="login-container">
      <div class="login-image">
        <van-image width="150" height="150" src="https://fastly.jsdelivr.net/npm/@vant/assets/logo.png" fit="contain" />
      </div>
      <div class="login-text">
        <h2>欢迎使用巨谷保龄球赛事系统</h2>
        <p>登录后即可享受更多功能</p>
      </div>
      <van-button type="primary" block round size="large" @click="handleLogin" class="login-button">
        立即登录
      </van-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import store from '@/store/index.js';
import env from '@/global/env';
import account from '@/api/account';
import util from '@/global/util';
import { showToast } from "vant";
import defaultAvatar from '@/assets/images/default-avatar.svg';

const router = useRouter();

// 这里可以添加组件的逻辑
let isLoggedIn = ref(false);
const userInfo = ref({
  avatar: null,
  name: '用户名',
});

onMounted(() => {
  checkAuth()
});

const checkAuth = () => {
  // 这里可以添加检查用户是否登录的逻辑
  store.dispatch('checkAuthStatus').then((res) => {
    if (res) {
      userInfo.value.name = store.state.user.name;
      isLoggedIn.value = true;
    } else {
      isLoggedIn.value = false;
    }
  });

  isLoggedIn.value = true; // 假设总是已登录，实际项目中应根据实际情况设置
};

const handleLogout = () => {
  // 实现退出登录的逻辑
  store.dispatch('logout').then(() => {
    isLoggedIn.value = false;
    showToast('已退出登录');
    router.push('/');
  });
};

const handleLogin = async () => {
  if (env.isWxEnv) {
    const appId = 'wx014c360d9c40c740';
    const host = window.location.href.split('#')[0];
    const redirectUri = host + "wechatLogin";
    const encodedRedirectUri = encodeURIComponent(redirectUri);
    const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    window.location.href = wechatAuthUrl;
  } else {
    if (env.isTestEnv) {
      //var loginResult = await account.loginByCaptcha("13311611186", "010203");
      var loginResult = await account.loginByCaptcha("13426197678", "010203");
      //var loginResult = await account.loginByPassword("LgwTest123", "LgwTest@123");

      if (util.isBlank(loginResult)) {
        showToast({ type: 'fail', message: '登录失败' });
      }
      else {
        var userId = loginResult.accountId;
        var token = loginResult.token;
        userInfo.value.name = loginResult.nickName;
        showToast({ type: 'success', message: '登录成功' });
        store.dispatch('login', [userId, token, loginResult.nickName]);
        checkAuth();
      }
    } else {
      alert("请在微信中打开");
    }
  }
}
</script>

<style scoped>
.my-page-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 20px;
}

.my-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 用户信息头部样式 */
.user-header {
  background: linear-gradient(135deg, #3f51b5 0%, #5c6bc0 100%);
  color: white;
  padding: 24px 16px;
  display: flex;
  align-items: center;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.user-details {
  margin-left: 16px;
  flex: 1;
}

.user-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
}

.user-id {
  font-size: 14px;
  opacity: 0.8;
}

/* 用户数据统计样式 */
.user-stats {
  display: flex;
  background-color: white;
  margin: 0 16px;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.stat-item {
  flex: 1;
  text-align: center;
  position: relative;
}

.stat-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  height: 60%;
  width: 1px;
  background-color: #ebedf0;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #969799;
}

/* 菜单区域样式 */
.menu-section,
.other-services {
  background-color: white;
  margin: 0 16px;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #323233;
}

/* 登录页面样式 */
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  height: 100vh;
  background-color: white;
}

.login-image {
  margin-bottom: 24px;
}

.login-text {
  text-align: center;
  margin-bottom: 32px;
}

.login-text h2 {
  font-size: 24px;
  color: #323233;
  margin-bottom: 8px;
}

.login-text p {
  font-size: 14px;
  color: #969799;
}

.login-button {
  width: 80%;
}

/* 退出登录按钮样式 */
.logout-cell {
  color: #ee0a24;
}

:deep(.van-grid-item__content) {
  padding: 16px 8px;
}

:deep(.van-cell-group--inset) {
  margin: 0;
}
</style>